const emptyStoreCollection = {
  byAggregateId: {},
  allAggregateIds: [],
};

export default class StoreCollection {
  constructor(data) {
    this.data = data || emptyStoreCollection;
  }

  toArray() {
    return this.data.allAggregateIds.map((aggregateId) => this.data.byAggregateId[aggregateId]);
  }

  has(aggregateId) {
    return this.data.allAggregateIds.indexOf(aggregateId) !== -1;
  }

  find(aggregateId) {
    return this.data.byAggregateId[aggregateId];
  }

  length() {
    return this.data.allAggregateIds.length;
  }

  getByIndex(index) {
    return this.data.byAggregateId[this.data.allAggregateIds[index]];
  }

  loop(eachCallback) {
    const notificationsArray = this.toArray();

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < notificationsArray.length; index++) {
      const notification = notificationsArray[index];

      eachCallback(notification, index);
    }
  }

  map(mapCallback) {
    return this.toArray().map(mapCallback);
  }

  setDataFromArray({ arrayData = [], idField = 'id' }) {
    this.data = this.convertToCollectionData(arrayData, idField);
  }

  static convertToCollectionData(arrayData, idField = 'id') {
    const collectionData = {
      byAggregateId: {},
      allAggregateIds: [],
    };

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < arrayData.length; index++) {
      const item = arrayData[index];
      const itemId = item[idField];
      collectionData.allAggregateIds.push(itemId);
      collectionData.byAggregateId[itemId] = item;
    }

    return collectionData;
  }

  get data() {
    // eslint-disable-next-line no-underscore-dangle
    return this._data;
  }

  set data(value) {
    // eslint-disable-next-line no-underscore-dangle
    this._data = value;
  }
}

StoreCollection.emptyStructure = emptyStoreCollection;
